import React, { useState } from 'react';
import { FaWhatsapp, FaFacebookF, FaTiktok, FaTimes, FaInstagram, FaYoutube } from 'react-icons/fa';
import { BsGridFill } from 'react-icons/bs';

const FloatingSocialMenu = () => {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => setOpen(!open);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Social Icons */}
      <div className={`flex flex-col items-end space-y-3 mb-4 transition-all duration-500 ease-in-out ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'} transform ${open ? 'translate-y-0' : 'translate-y-4'}`}>
        <a
          href="https://wa.me/94777129021"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg animate-pulse"
        >
          <FaWhatsapp size={20} />
        </a>
        <a
          href="https://web.facebook.com/profile.php?id=100091148180919"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg animate-pulse"
        >
          <FaFacebookF size={20} />
        </a>
        <a
          href="https://www.instagram.com/solar_care_international/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gradient-to-tr from-pink-500 via-red-500 to-yellow-500 hover:opacity-90 text-white p-4 rounded-full shadow-lg animate-pulse"
        >
          <FaInstagram size={20} />
        </a>
        <a
          href="https://www.youtube.com/@SolarCareInternational"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-red-600 hover:bg-red-700 text-white p-4 rounded-full shadow-lg animate-pulse"
        >
          <FaYoutube size={20} />
        </a>
        <a
          href="https://www.tiktok.com/@solarcareinternational"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-black hover:bg-gray-800 text-white p-4 rounded-full shadow-lg animate-pulse"
        >
          <FaTiktok size={20} />
        </a>
      </div>

      {/* Toggle Button */}
      <button
        onClick={toggleMenu}
        className="bg-purple-600 hover:bg-purple-700 text-white p-5 rounded-full shadow-xl transition transform hover:scale-110"
      >
        {open ? <FaTimes size={20} /> : <BsGridFill size={20} />}
      </button>
    </div>
  );
};

export default FloatingSocialMenu;